import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { postSession } from "../lib/api";
import { useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    const finish = async () => {
      if (!sessionId) {
        navigate("/admin/login");
        return;
      }
      try {
        const me = await postSession(sessionId);
        setUser(me);
        window.history.replaceState(null, "", window.location.pathname);
        navigate(me.is_admin ? "/admin" : "/account", { replace: true, state: { user: me } });
      } catch {
        navigate("/admin/login", { replace: true });
      }
    };
    finish();
  }, [navigate, setUser]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="w-10 h-10 border-4 border-[#0e2a1e]/20 border-t-[#0e2a1e] rounded-full animate-spin" />
    </div>
  );
};

export default AuthCallback;
